import { gql } from "@apollo/client";

export const DELETE_USER_REPORT = gql`
  mutation adminDeleteUserReport($id: String!) {
    adminDeleteUserReport(id: $id) {
      status
    }
  }
`;
